import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';

/** Clones a request, attaching the given bearer token as the Authorization header. */
export const addBearerToken = (request: HttpRequest<any>, token: string): HttpRequest<any> =>
  request.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

/**
 * Waits for an in-flight token refresh (published on `refreshTokenSubject`) to complete,
 * then retries `request` with the freshly refreshed token.
 *
 * Shared by the auth and Sony HTTP error interceptors, which differ only in how the
 * bearer token is read out of their respective refreshed-token payloads.
 */
export const retryAfterTokenRefresh = <T>(
  refreshTokenSubject: Observable<T | null>,
  request: HttpRequest<any>,
  next: HttpHandler,
  getToken: (tokens: T) => string,
): Observable<HttpEvent<any>> =>
  refreshTokenSubject.pipe(
    filter((tokens): tokens is T => tokens != null),
    take(1),
    switchMap((tokens) => next.handle(addBearerToken(request, getToken(tokens)))),
  );
